import {config} from "../config";
import {PredefinedPIXIAnchorPoint} from "../PredefinedPIXIAnchorPoint";
import {CustomSpineAnimation} from "./CustomSpineAnimation";
import {VideoPokerCardCombinationName} from "./VideoPokerCardCombinationName";

export class WinPopupAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "winPopupAnimation",
        STATES: {
            JACKS_OR_BETTER: "jacks_or_better",
            TWO_PAIRS: "two_pairs",
            THREE_OF_A_KIND: "three_of_a_kind",
            STRAIGHT: "straight",
            FLUSH: "flush",
            FULL_HOUSE: "full_house",
            FOUR_OF_A_KIND: "four_of_a_kind",
            STRAIGHT_FLUSH: "straight_flush",
            ROYAL_STRAIGHT_FLUSH: "royal_straight_flush",
        },
        SLOT_CONTAINERS: {
            REWARD: "reward",
        },
    };

    private readonly WIN_VALUE_TEXT_STYLE = {
        fontSize: 24,
        fontFamily: "RobotoRegular",
        dropShadow: true,
        dropShadowAngle: 1.4,
        dropShadowBlur: 3,
        dropShadowDistance: 3,
        fill: "#fff",
        fontWeight: "bolder",
    };

    private winValueText: PIXI.Text;

    constructor() {
        super(WinPopupAnimation.ANIMATION_CONFIG.NAME);
        this.createAndAddWinValueText();
    }

    public showWinBanner(videoPokerCardCombinationName: VideoPokerCardCombinationName,
                         amountWon: number, currencyType: string): void {
        this.winValueText.text = "YOU WON " + amountWon.toFixed(config.betDisplayPrecision) + " " + config.displayCurrency;
        switch (videoPokerCardCombinationName) {
            case VideoPokerCardCombinationName.JACKS_OR_BETTER:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.JACKS_OR_BETTER);
                break;
            case VideoPokerCardCombinationName.TWO_PAIRS:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.TWO_PAIRS);
                break;
            case VideoPokerCardCombinationName.THREE_OF_A_KIND:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.THREE_OF_A_KIND);
                break;
            case VideoPokerCardCombinationName.STRAIGHT:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.STRAIGHT);
                break;
            case VideoPokerCardCombinationName.FLUSH:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.FLUSH);
                break;
            case VideoPokerCardCombinationName.FULL_HOUSE:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.FULL_HOUSE);
                break;
            case VideoPokerCardCombinationName.FOUR_OF_A_KIND:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.FOUR_OF_A_KIND);
                break;
            case VideoPokerCardCombinationName.STRAIGHT_FLUSH:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.STRAIGHT_FLUSH);
                break;
            case VideoPokerCardCombinationName.ROYAL_FLUSH:
                this.play(WinPopupAnimation.ANIMATION_CONFIG.STATES.ROYAL_STRAIGHT_FLUSH);
                break;
        }
    }

    private createAndAddWinValueText(): void {
        this.winValueText = new PIXI.Text("", this.WIN_VALUE_TEXT_STYLE);
        this.winValueText.position.y = -2;
        this.winValueText.scale.y = -1;
        this.winValueText.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.getSlotContainer(WinPopupAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.REWARD).addChild(this.winValueText);
    }
}



// WEBPACK FOOTER //
// ./src/app/WinPopupAnimation.ts